import React from "react";
import "./LoadingMessage.css";

const LoadingMessage = () => {
  return (
    <div className="wrapper">
      <div className="logo-loader">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          xmlnsXlink="http://www.w3.org/1999/xlink"
          viewBox="0 0 361.78 287.32"
          width="96"
          height="96"
        >
          <defs>
            <linearGradient id="ll-lg-left" x1="172.87" y1="140.75" x2="99.14" y2="208.71" gradientUnits="userSpaceOnUse">
              <stop offset=".14" stopColor="#007559" />
              <stop offset=".48" stopColor="#6fba79" />
            </linearGradient>
            <linearGradient id="ll-lg-right" x1="237.9" y1="137.37" x2="157.27" y2="239.27" gradientUnits="userSpaceOnUse">
              <stop offset=".14" stopColor="#007559" />
              <stop offset=".48" stopColor="#6fba79" />
            </linearGradient>
          </defs>

          <g className="chevron-left">
            <path
              d="M167.82,109.5l16.22,24.36c3.67,5.52,3.74,12.69.17,18.28l-20.54,30.88c-8.07,12.96-15.63,14.17-28.3,14.17h-21.08c-4.14.25-3.55-2.46-2.34-4.31l55.86-83.37Z"
              fill="url(#ll-lg-left)"
            />
            <path
              d="M167.82,176.78l16.21-24.37c3.7-5.58,3.75-12.68.18-18.27l-20.54-30.88c-8.07-12.96-15.63-14.17-28.3-14.17h-21.08c-4.14-.25-3.55,2.46-2.34,4.31l55.86,83.37Z"
              fill="#55b370"
            />
          </g>

          <g className="chevron-right">
            <path
              d="M231.61,110.14l16.37,24.13c3.67,5.52,3.74,12.69.17,18.28l-32.57,47.95c-6.15,9.63-16.79,15.46-28.21,15.46h-21.08c-2.21,0-3.55-2.46-2.34-4.31l67.66-101.5Z"
              fill="url(#ll-lg-right)"
            />
            <path
              d="M231.59,176.88l16.42-24.12c3.74-5.66,3.64-12.77.07-18.36l-32.57-47.95c-6.15-9.63-16.79-15.46-28.21-15.46h-21.08c-2.21,0-3.55,2.46-2.34,4.31l67.72,101.59Z"
              fill="#55b370"
            />
          </g>
        </svg>
      </div>
    </div>
  );
};

export default LoadingMessage;
